// @ts-strict-ignore
import { createModel, RematchRootState } from '@rematch/core';
import { IProviderClient } from '../../../../api/Providers/Clients/types';
import { PrivilegedProvider } from '../../../../api/Providers';
import type { RootModel } from '../../../../store/models';

type State = {
  loading: boolean;
  providerId?: number;
};

export type ProClientListPageData = State & {
  provider: PrivilegedProvider;
};

export type ProClientDetailPageData = {
  client: IProviderClient;
};

const defaultState: State = {
  loading: false,
};

const model = createModel<RootModel>()({
  name: 'proClientList',

  state: defaultState,

  reducers: {
    onLoading: (state, {
      providerId,
    }) => ({
      loading: true,
      providerId,
    }),

    onLoaded: (state, {
      providerId,
    }) => ({
      loading: false,
      providerId,
    }),
  },

  effects: dispatch => ({
    detailsLand: async (
      payload: { providerId: number; clientId: number },
    ) => {
      const { providerId, clientId } = payload;
      await dispatch.providerClients.loadClient({ clientId, providerId });
      await dispatch.providerClients.loadClientSMSStatus({
        providerId,
        clientId,
      });
    },
  }),

  selectors: (slice, createSelector) => ({
    getDetailsPageData: () => createSelector<
    RematchRootState<RootModel>,
    Record<number, IProviderClient>,
    string,
    ProClientDetailPageData
    >(
      state => state.providerClients.clients,
      state => state.route.params?.clientId,
      (clients, clientId): ProClientDetailPageData => ({
        client: clients[Number(clientId)],
      }),
    ),
  }),
});

export default model;
